import { render, staticRenderFns } from "./ReLike.vue?vue&type=template&id=d038b9b6&scoped=true"
import script from "./ReLike.vue?vue&type=script&lang=js"
export * from "./ReLike.vue?vue&type=script&lang=js"
import style0 from "./ReLike.vue?vue&type=style&index=0&id=d038b9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d038b9b6",
  null
  
)

export default component.exports